export const ActionTypes = {
  LOADING: "REQ_OTP_LOADING",
  ERROR: "REQ_OTP_ERROR",
  SUCCESS: "REQ_OTP_SUCCESS",
};
